import { ComponentPropsWithoutRef, ForwardedRef, forwardRef } from 'react';
import * as Dialog from 'components/dialog';
import { twMerge } from 'tailwind-merge';

interface BuilderFrameContainerProps extends ComponentPropsWithoutRef<'div'> {}
const BuilderFrameContainer = forwardRef(
    (
        { className, ...restProps }: BuilderFrameContainerProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <Dialog.Root open modal={false}>
                <Dialog.Portal>
                    <Dialog.Content variant="fullscreen" className="animate-none">
                        <div
                            className={twMerge('flex h-full flex-col bg-white', className)}
                            ref={forwardedRef}
                            {...restProps}
                        />
                    </Dialog.Content>
                </Dialog.Portal>
            </Dialog.Root>
        );
    },
);
BuilderFrameContainer.displayName = 'BuilderFrameContainer';

interface BuilderFrameTitleProps extends ComponentPropsWithoutRef<'div'> {}
const BuilderFrameTitle = forwardRef(
    (
        { className, ...restProps }: BuilderFrameTitleProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <Dialog.Title
                ref={forwardedRef}
                className={twMerge('sr-only', className)}
                {...restProps}
            />
        );
    },
);
BuilderFrameTitle.displayName = 'BuilderFrameTitle';

interface BuilderFrameHeaderProps extends ComponentPropsWithoutRef<'div'> {}
const BuilderFrameHeader = forwardRef(
    (
        { className, ...restProps }: BuilderFrameHeaderProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <div
                className={twMerge(
                    'flex flex-shrink-0 flex-wrap items-center justify-between gap-2 border-b border-b-gray-200 bg-gray-50 p-2 md:px-7 md:py-4',
                    className,
                )}
                ref={forwardedRef}
                {...restProps}
            />
        );
    },
);
BuilderFrameHeader.displayName = 'BuilderFrameHeader';

interface BuilderFrameContentProps extends ComponentPropsWithoutRef<'div'> {}
const BuilderFrameContent = forwardRef(
    (
        { className, ...restProps }: BuilderFrameContentProps,
        forwardedRef: ForwardedRef<HTMLDivElement>,
    ) => {
        return (
            <div
                className={twMerge('h-full min-h-0 flex-grow', className)}
                ref={forwardedRef}
                {...restProps}
            />
        );
    },
);
BuilderFrameContent.displayName = 'BuilderFrameContent';

const Root = BuilderFrameContainer;
const Title = BuilderFrameTitle;
const Header = BuilderFrameHeader;
const Content = BuilderFrameContent;

export {
    BuilderFrameContainer,
    BuilderFrameTitle,
    BuilderFrameHeader,
    BuilderFrameContent,
    //
    Root,
    Title,
    Header,
    Content,
};
